import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const checkAvaiableHours = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.COLABORADOR.TURNOS.COMPROBAR_HORARIO}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default checkAvaiableHours;